var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('home'),_c('div',{staticClass:"contentBlock"},[_c('DingBU'),_c('div',{staticStyle:{"position":"relative"}},[_c('InputData',{ref:"submit"})],1)],1),_c('earnings',{on:{"BtnSubmitBtn":_vm.BtnSubmitBtn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }